import React from 'react'
import PropTypes from 'prop-types'
import styles from './style.module.scss'
import MyImage from '@shared/components/myImage'

function F1TeamSlider({ data }) {
  return (
    <div
      className='position-relative overflow-hidden'
    >
      <div className={styles.teamSlider}>
        <MyImage
          src={data?.sSlideCarImgUrl}
          width={100}
          height={100}
          alt={'slider-image'}
        />
      </div>
    </div>
  )
}

F1TeamSlider.propTypes = {
  data: PropTypes.object.isRequired
}

export default F1TeamSlider
